<template>
  <div class="terms-of-service-page">
    <LegalPageHero title="Terms of Service" />
    <LegalDocumentContent>
      <p class="legal-intro">
        Welcome to Eddy, a product developed by edm8ker Inc. ("we," "us,"
        "our"). By using our website and services, you agree to the following
        Terms of Service:
      </p>

      <section class="legal-section">
        <h2 class="legal-section__title">1. Use of Our Website</h2>
        <div class="legal-section__body">
          <p>
            You may use our website for lawful purposes only. You may not use
            our website to:
          </p>
          <ul>
            <li>Violate any applicable laws or regulations.</li>
            <li>Infringe on the intellectual property rights of others.</li>
            <li>Transmit any viruses, malware, or other harmful software.</li>
            <li>
              Engage in any activity that is harmful, obscene, or offensive.
            </li>
          </ul>
        </div>
      </section>

      <section class="legal-section">
        <h2 class="legal-section__title">2. User Accounts</h2>
        <div class="legal-section__body">
          <p>
            If you create an account on our website, you are responsible for
            maintaining the security of your account and password. You may not
            share your account or password with anyone else. You are also
            responsible for any activity that occurs on your account.
          </p>
        </div>
      </section>

      <section class="legal-section">
        <h2 class="legal-section__title">3. Intellectual Property</h2>
        <div class="legal-section__body">
          <p>
            All content on our website, including text, images, graphics, and
            logos, is the property of edm8ker Inc. or its licensors and is
            protected by intellectual property laws. You may not use or
            reproduce our content without our permission.
          </p>
        </div>
      </section>

      <section class="legal-section">
        <h2 class="legal-section__title">4. Disclaimer of Warranties</h2>
        <div class="legal-section__body">
          <p>
            Our website and services are provided "as is" and without warranties
            of any kind, whether express or implied. We do not guarantee that
            our website will be error-free or that our services will meet your
            expectations.
          </p>
        </div>
      </section>

      <section class="legal-section">
        <h2 class="legal-section__title">5. Limitation of Liability</h2>
        <div class="legal-section__body">
          <p>
            We will not be liable for any damages arising from the use of our
            website or services. This includes direct, indirect, incidental, and
            consequential damages. Some jurisdictions do not allow the exclusion
            or limitation of liability for certain types of damages, so the
            above limitations may not apply to you.
          </p>
        </div>
      </section>

      <section class="legal-section">
        <h2 class="legal-section__title">6. Indemnification</h2>
        <div class="legal-section__body">
          <p>
            You agree to indemnify, defend, and hold edm8ker Inc. harmless from
            any claims, damages, or expenses arising from your use of our
            website or services or your violation of these Terms of Service.
          </p>
        </div>
      </section>

      <section class="legal-section">
        <h2 class="legal-section__title">7. Termination</h2>
        <div class="legal-section__body">
          <p>
            We may terminate your access to our website or services at any time
            for any reason without notice.
          </p>
        </div>
      </section>

      <section class="legal-section">
        <h2 class="legal-section__title">8. Governing Law</h2>
        <div class="legal-section__body">
          <p>
            These Terms of Service will be governed by and construed in
            accordance with the laws of the United States of America. Any legal
            action arising from these Terms of Service must be brought in the
            courts located in the United States of America.
          </p>
        </div>
      </section>

      <section class="legal-section">
        <h2 class="legal-section__title">9. Changes to These Terms</h2>
        <div class="legal-section__body">
          <p>
            We may update these Terms of Service from time to time. If we make
            significant changes, we will notify you by posting a prominent
            notice on our website or by sending you an email.
          </p>
        </div>
      </section>

      <section class="legal-section">
        <h2 class="legal-section__title">10. Contact Us</h2>
        <div class="legal-section__body">
          <p>
            If you have any questions or concerns about our Terms of Service,
            please contact us at hello@eddy4teachers.com.
          </p>
        </div>
      </section>
    </LegalDocumentContent>
  </div>
</template>

<script setup>
import LegalPageHero from "@/components/legal/LegalPageHero.vue";
import LegalDocumentContent from "@/components/legal/LegalDocumentContent.vue";
</script>

<style scoped>
.terms-of-service-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: var(--white);
}

@media (max-width: 768px) {
  .terms-of-service-page {
    gap: 0;
  }
}
</style>
